import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  right: 10px;
  width: 350px;
  max-height: ${(props) => (props.isOpen ? `calc(100vh - 60px)` : `30px`)};
  display: flex;
  flex-direction: column;
  font-family: 'Nunito', sans-serif;
  transition: max-height 0.3s ease-in-out, width 0.3s ease;
  z-index: 50;
  border: 1px solid rgba(244, 241, 222, 0.2);
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  border-radius: 12px 12px 0 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(circle at 20% 80%, rgba(244, 241, 222, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(244, 241, 222, 0.08) 0%, transparent 50%);
    pointer-events: none;
    border-radius: 12px 12px 0 0;
  }

  @media (max-width: 768px) {
    right: 10px;
    width: calc(100% - 20px);
    max-width: 350px;
    bottom: 0;
  }

  @media (max-width: 470px) {
    right: 5px;
    width: calc(100% - 10px);
    max-width: 300px;
    bottom: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background: rgba(244, 241, 222, 0.1);
  color: #f4f1de;
  cursor: pointer;
  width: 348px;
  transition: width 0.3s ease;
  border-radius: 12px 12px 0 0;
  font-weight: 600;
  font-size: 14px;
  position: relative;
  z-index: 2;
  backdrop-filter: blur(10px);

  .header-content {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .header-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .title {
    font-weight: 600;
    font-size: 14px;
    color: #f4f1de;
  }

  .subtitle {
    font-weight: 400;
    font-size: 11px;
    color: rgba(244, 241, 222, 0.7);
    line-height: 1.2;
  }

  .solis-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    border-radius: 50%;
    border: 1px solid rgba(244, 241, 222, 0.3);
    color: #f4f1de;
    overflow: hidden;

    img {
      width: 20px;
      height: 20px;
      object-fit: cover;
      border-radius: 50%;
    }
  }

  &:hover {
    background: rgba(244, 241, 222, 0.15);
  }

  @media (max-width: 768px) {
    width: 100%;
  }

  @media (max-width: 470px) {
    width: 100%;
    padding: 12px 12px;

    .subtitle {
      font-size: 10px;
    }
  }
`;

export const ChatBox = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  margin: 0;
  background: rgba(244, 241, 222, 0.05);
  position: relative;
  z-index: 1;
  min-height: 200px;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(244, 241, 222, 0.1);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(244, 241, 222, 0.3);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(244, 241, 222, 0.5);
  }

  @media (max-width: 470px) {
    padding: 8px;
    min-height: 150px;
  }
`;

export const Message = styled.div`
  display: flex;
  justify-content: ${(props) => (props.isUser ? 'flex-end' : 'flex-start')};
  margin-bottom: 10px;

  @media (max-width: 470px) {
    margin-bottom: 8px;
  }

  /* Estilos específicos para mensagens do usuário */
  #user-message {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
  }

  /* Estilos específicos para mensagens da Solis */
  #solis-message {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 8px;
    width: 100%;
  }
`;

export const MessageBubble = styled.div`
  max-width: 95%;
  padding: 10px 14px;
  background: ${(props) => (props.isUser ? 'rgba(244, 241, 222, 0.2)' : 'rgba(244, 241, 222, 0.1)')};
  color: ${(props) => (props.isUser ? '#f4f1de' : 'rgba(244, 241, 222, 0.9)')};
  border: ${(props) => (props.isUser ? '1px solid rgba(244, 241, 222, 0.3)' : '1px solid rgba(244, 241, 222, 0.2)')};
  border-radius: ${(props) =>
    props.isUser ? '18px 18px 4px 18px' : '18px 18px 18px 4px'};
  word-wrap: break-word;
  white-space: pre-wrap;
  box-shadow: ${(props) => (props.isUser ? '0 2px 8px rgba(244, 241, 222, 0.2)' : '0 1px 4px rgba(244, 241, 222, 0.1)')};
  backdrop-filter: blur(10px);
  font-size: 14px;
  line-height: 1.4;

  @media (max-width: 470px) {
    padding: 8px 12px;
    font-size: 13px;
  }
`;

export const SolisAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-radius: 50%;
  border: 1px solid rgba(244, 241, 222, 0.3);
  color: #f4f1de;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 24px;
    height: 24px;
    object-fit: cover;
    border-radius: 50%;
  }

  @media (max-width: 470px) {
    width: 24px;
    height: 24px;
    margin-right: 6px;

    img {
      width: 20px;
      height: 20px;
    }
  }
`;

export const UserAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #0f3460 0%, #16213e 100%);
  border-radius: 50%;
  border: 1px solid rgba(244, 241, 222, 0.3);
  color: #f4f1de;
  flex-shrink: 0;

  @media (max-width: 470px) {
    width: 24px;
    height: 24px;
    margin-left: 6px;
  }
`;

export const InputTextarea = styled.textarea`
  border: 1px solid rgba(244, 241, 222, 0.3);
  padding: 12px;
  resize: none;
  box-sizing: border-box;
  min-height: 50px;
  overflow: hidden;
  outline: none;
  border-right: none;
  border-left: none;
  color: #f4f1de;
  caret-color: #f4f1de;
  margin: 10px 5px 5px 5px;
  border-radius: 12px;
  background: rgba(244, 241, 222, 0.1);
  font-family: 'Nunito', sans-serif;
  backdrop-filter: blur(10px);
  font-size: 14px;

  &:focus {
    border-color: #f4f1de;
    box-shadow: 0 0 0 2px rgba(244, 241, 222, 0.2);
    background: rgba(244, 241, 222, 0.15);
  }

  &::placeholder {
    color: rgba(244, 241, 222, 0.6);
  }

  @media (max-width: 470px) {
    padding: 8px;
    min-height: 40px;
    margin: 8px 3px 3px 3px;
    font-size: 14px;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: #f4f1de;
  font-size: 16px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-weight: 600;
  position: relative;
  z-index: 3;

  &:hover {
    background-color: rgba(244, 241, 222, 0.2);
    transform: scale(1.1);
  }

  @media (max-width: 470px) {
    font-size: 14px;
    padding: 4px 8px;
  }
`;

export const CollapsedChatIcon = styled.div`
  position: fixed;
  bottom: 20px;
  right: 50px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #f4f1de;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  z-index: 50;
  border: 1px solid rgba(244, 241, 222, 0.2);
  backdrop-filter: blur(10px);

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
    background: linear-gradient(135deg, #16213e 0%, #0f3460 100%);
    border-color: rgba(244, 241, 222, 0.4);
  }

  .chat-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  &:hover .chat-icon {
    transform: scale(1.1);
  }



  @media (max-width: 768px) {
    bottom: 15px;
    right: 15px;
    width: 40px;
    height: 40px;
  }

  @media (max-width: 470px) {
    bottom: 10px;
    right: 10px;
    width: 35px;
    height: 35px;
  }
`;

export const NotificationBadge = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ef4444;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  border: 2px solid white;

  @media (max-width: 470px) {
    width: 16px;
    height: 16px;
    font-size: 9px;
  }
`;

export const TypingIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(244, 241, 222, 0.8);
  font-size: 14px;

  @media (max-width: 470px) {
    font-size: 12px;
    gap: 6px;
  }
`;

export const TypingDots = styled.div`
  display: flex;
  gap: 2px;

  span {
    width: 4px;
    height: 4px;
    background: rgba(244, 241, 222, 0.8);
    border-radius: 50%;
    animation: typing 1.4s infinite ease-in-out;

    &:nth-child(1) {
      animation-delay: -0.32s;
    }

    &:nth-child(2) {
      animation-delay: -0.16s;
    }
  }

  @keyframes typing {
    0%, 80%, 100% {
      transform: scale(0.8);
      opacity: 0.5;
    }
    40% {
      transform: scale(1);
      opacity: 1;
    }
  }

  @media (max-width: 470px) {
    gap: 1px;

    span {
      width: 3px;
      height: 3px;
    }
  }
`;

export const FloatingChatText = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 260px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  color: #f4f1de;
  padding: 12px 16px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  z-index: 1;
  border: 1px solid rgba(244, 241, 222, 0.2);
  backdrop-filter: blur(10px);
  display: block;

  &:hover {
    background: linear-gradient(135deg, #16213e 0%, #0f3460 100%);
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
  }

  @media (max-width: 768px) {
    right: 15px;
    width: 264px;
    bottom: 15px;
    padding: 10px 14px;
    font-size: 13px;
  }

  @media (max-width: 470px) {
    right: 10px;
    width: 268px;
    bottom: 10px;
    padding: 8px 12px;
    font-size: 12px;
  }
`;

export const HoverDiv = styled.div`
  position: fixed;
  bottom: 27px;
  right: 90px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  color: #f4f1de;
  padding: 12px 25px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(244, 241, 222, 0.2);
  backdrop-filter: blur(10px);
  z-index: 49;
  animation: slideIn 0.3s ease;
  cursor: pointer;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @media (max-width: 768px) {
    bottom: 30px;
    right: 65px;
    padding: 10px 14px;
    font-size: 13px;
  }

  @media (max-width: 470px) {
    bottom: 25px;
    right: 60px;
    padding: 8px 12px;
    font-size: 12px;
  }
`;
